import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ECRRequestsActions, ECRRequestsSelectors, fromECRRequests } from '@ruby/modules/ecr/store/ecr-requests.index';
import { IECRPattern } from '@ruby/shared/models/ecr/ecr.interface';

@Component({
  selector: 'ng-ecr-requests-container',
  templateUrl: './ecr-requests.container.html',
  styleUrls: ['./ecr-requests.container.scss']
})
export class ECRRequestsContainer {
  store$: Observable<{ state: fromECRRequests.State; patterns: Array<IECRPattern>; dates: { start: number; end: number } }>;
  patterns: Array<IECRPattern> = [];

  constructor(private store: Store<{ state: fromECRRequests.State; patterns: Array<IECRPattern>; dates: { start: number; end: number } }>) {
    this.store$ = this.store.select(ECRRequestsSelectors.selectRequestsState).pipe(tap(
      (st: { state: fromECRRequests.State; patterns: Array<IECRPattern>; dates: { start: number; end: number } }) => {
        /* istanbul ignore next */
        if (st.patterns.length > 0 && this.patterns !== st.patterns) {
          this.patterns = st.patterns;
          this.store.dispatch(ECRRequestsActions.loadRequests({
            data: {
              startDate: st.dates.start,
              endDate: st.dates.end,
              carRequest: st.patterns.map((pattern: IECRPattern) => ({
                classCode: pattern.classCode,
                locationId: pattern.locationId,
                opStaCode: pattern.opStaCode,
                patterns: pattern.patterns,
                servingRoad: pattern.servingRoad
              }))
            }
          }));
        }
      })
    );
  }
}
